import { Directive, ElementRef, Renderer2, inject } from '@angular/core';

/**
 * Generalisierte Umsetzung der Sicherheitsmaßnahme M-118
 * Direktive zum Setzen von rel="noreferrer", wenn das HTML-Attribut target="_blank" gesetzt ist.
 * Beim Öffnen eines neuen Tabs per target="_blank" darf kein Referrer gesetzt sein. Diese Direktive wird überall aktiv,
 * wo die ng-lib eingebunden ist und gilt damit automatisch.
 */
@Directive({
  /*
      "The selector should be prefixed by "baBub" (https://angular.io/guide/styleguide#style-02-08)"
      wir wollen hier wissentlich das native HTML-Element beeinflussen und verwenden deswegen KEINEN prefix
      Autor  PJO 11.05.20
      Review CKU 11.08.20
    */
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[target]'
})
export class NoReferrerDirective {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  constructor() {
    const target = this.el.nativeElement.getAttribute('target');
    if (target === '_blank') {
      this.renderer.setAttribute(this.el.nativeElement, 'rel', 'noreferrer');
    }
  }
}
